import { XPartnerService } from './../../../../shared/services/x-partner.service';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Config } from '@shared/configs/config';
import { AuthController } from '@modules/authorization/shared/controllers/auth.controller';
import { ActivatedRoute } from '@angular/router';
import { NavigateService } from '@core/routes/services/navigate.service';
import { AuthGraphqlService } from '@modules/authorization/shared/graphql/auth.graphql.service';
import { UserService } from '@shared/services/user.service';
import { AuthStorageService } from '@core/services/auth-storage.service';

@Component({
  selector: 'df-confirm-change-email',
  templateUrl: './confirm-change-email.component.html',
  styleUrls: ['../../shared/scss/auth-panel.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmChangeEmailComponent implements OnInit {
  Config = Config;

  confirmed: boolean | null = null;
  loading = false;
  authController: AuthController = new AuthController();

  constructor(
    private route: ActivatedRoute,
    private n: NavigateService,
    private authGraphqlService: AuthGraphqlService,
    private changes: ChangeDetectorRef,
    private userService: UserService,
    private authStorageService: AuthStorageService,
    public xPartnerService: XPartnerService,
  ) {}

  ngOnInit(): void {
    if (this.route.snapshot.params['token']) {
      this.confirmEmail(this.route.snapshot.params['token']);
    }
  }

  login() {
    this.n.go('sign-in');
  }

  confirmEmail(token: string) {
    this.loading = true;
    this.authGraphqlService
      .confirmChangeEmail(token)
      .subscribe({
        next: () => {
          this.confirmed = true;
          if (this.userService.User && this.authStorageService.jwt) {
            this.n.go(Config.MAIN_VIEW);
          } else {
            this.n.go('sign-in');
          }
        },
        error: () => {
          this.confirmed = false;
        },
      })
      .add(() => {
        this.loading = false;
        this.changes.detectChanges();
      });
  }
}
